import { HostListener, Directive, Input, ElementRef } from "@angular/core";

@Directive({
  selector: `[mailTo]`
})
export class MailToDirective {
  @Input("mailTo") mail: string;
  @Input() subject = "";
  @Input() body = "";

  constructor(public el: ElementRef) {}

  @HostListener("click", ["$event"])
  confirmFirst(event: Event) {
    if (!this.mail || this.mail == "") {
      return;
    }

    document.location.href = `mailto:${this.mail}?subject=${encodeURIComponent(
      this.subject
    )}&body=${encodeURIComponent(this.body)}`;
  }

  @HostListener("mouseenter")
  onMouseEnter() {
    this.highlight("blue");
  }

  @HostListener("mouseleave")
  onMouseLeave() {
    this.highlight("");
  }

  highlight(color: string) {
    this.el.nativeElement.style.cursor = "pointer";
    this.el.nativeElement.style.color = color;
  }
}
